module.exports = __webpack_public_path__ + "img/banano.373412c42e56103e2458901656b877e4.svg";